import React, { Component } from 'react';
//import { Redirect, Link  } from 'react-router-dom';  
//import { connect } from 'react-redux';
import LogComponent from './logComponent';
import {userGroupUrlCheck} from '../../utils/userGroupUrlCheck';

import {LOGIN_AFFILIATE_GROUP, LOGIN_CLIENT_GROUP} from '../../configs/staticConfigs'; 
import { LBL_APP_NAME, LBL_LOGS} from '../../configs/labelConfigs';

class ActivityLogComponent extends Component { 

    constructor(props){
        super(props)

        this.state = {
        }
    }

    componentDidMount() {
        const { location } = this.props;
        let userGroupData = userGroupUrlCheck(location);
        let userGroup = ''; 
        if(userGroupData!==undefined){
           userGroup = userGroupData.user_group; 
        }   
        if(userGroup===LOGIN_AFFILIATE_GROUP){
           document.body.classList.add('body-affiliate'); 
        }else if(userGroup===LOGIN_CLIENT_GROUP){
           document.body.classList.add('body-client'); 
        } else{
            document.body.classList.add('body-super');
        }
        document.title = LBL_APP_NAME+" - "+LBL_LOGS;
     }

    render(){
        let dataObj = {refType:'logMasterPage', refId:0};
        return( 
            <>
               <LogComponent location={this.props.location} dataObj={dataObj} />
            </> 
        )
    }
}

      

export default ActivityLogComponent;

        